module.exports = __webpack_public_path__ + "img/desc.0ef99322.png";